import Modal from "@common/Modal"

export default function AddonModal(props: any) {
    let { handleClose, show, title, description } = props
    return (
        <div className="model-outer upload-error-popup addon-popup">
            <Modal show={show} handleClose={() => { handleClose() }}>
                <div className="modal-header">
                    <div className="addon-img">
                        <img src="/images/info.png" alt=""/>
                    </div>
                </div>
                <div className='modal-body'>
                    <h2>What is {title} ?</h2>
                    <p>
                        {description}
                    </p>
                </div>
            </Modal>
        </div>
    )
}